import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownDropdown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 5.5L8 10.5L3 5.5",
		stroke: "#F5F5F5",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowDownDropdown;
